import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../services/api";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    token: searchParams.get("token") || "",
    password: "",
    confirm: "",
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (form.password !== form.confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await authApi.resetPassword({ token: form.token, password: form.password });
      setSuccess("Password updated. You can sign in now.");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      setError(err.message || "Unable to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hm-auth-shell">
      <div className="hm-auth-card">
        <div className="hm-auth-brand">
          <strong>HouseMind</strong>
          <span>Reset your password</span>
        </div>
        <h1 className="hm-auth-title">Choose a new password</h1>
        {error && <div className="hm-auth-error">{error}</div>}
        {success && (
          <div
            className="hm-auth-error"
            style={{
              background: "rgba(42,123,111,0.10)",
              borderColor: "rgba(42,123,111,0.28)",
              color: "var(--hm-cyan)",
            }}
          >
            {success}
          </div>
        )}
        <form onSubmit={handleSubmit} className="hm-auth-form">
          <label className="hm-auth-label">
            Reset token
            <input className="hm-auth-input" value={form.token} onChange={set("token")} required />
          </label>
          <label className="hm-auth-label">
            New password
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                className="hm-auth-input"
                value={form.password}
                onChange={set("password")}
                required
                autoComplete="new-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
            {form.password.length > 0 && form.password.length < 8 && (
              <div className="field-warn">
                {8 - form.password.length} more character{8 - form.password.length !== 1 ? "s" : ""} needed
              </div>
            )}
          </label>
          <label className="hm-auth-label">
            Confirm password
            <div className="password-field">
              <input
                type={showConfirm ? "text" : "password"}
                className="hm-auth-input"
                value={form.confirm}
                onChange={set("confirm")}
                required
                autoComplete="new-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirm(v => !v)}
                aria-label={showConfirm ? "Hide password" : "Show password"}
              >
                {showConfirm ? "Hide" : "Show"}
              </button>
            </div>
          </label>
          <button type="submit" className="hm-auth-btn" disabled={loading}>
            {loading ? "Updating..." : "Reset password"}
          </button>
        </form>
        <p className="hm-auth-foot">
          Back to <Link to="/login" className="hm-auth-link">sign in</Link>
        </p>
      </div>
    </div>
  );
}
